import { InjectionToken, inject, computed } from '@angular/core';
import { Signal } from '@angular/core';

export interface ClientStore {
  client: Signal<{ id: string } | null | undefined>;
}

// 앱에서 ClientStore를 제공하기 위한 InjectionToken
export const CLIENT_STORE = new InjectionToken<ClientStore>('CLIENT_STORE');

export function injectClientStore(): ClientStore {
  return (
    inject(CLIENT_STORE, { optional: true }) || {
      client: computed(() => null),
    }
  );
}
